import React, { useState } from "react";
import Dropzone from "react-dropzone";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
} from "reactstrap";
import { BlobServiceClient } from "@azure/storage-blob";
import "./ocrDropZone.scss";
import { UploadFileTypesPayload } from "../../../commonTypes/fileManagerTypes";
import { RedDeleteIcon, UploadIcon, WarningIcon } from "../../../assets/images";
import { CommonHeader, Loader } from "../../commons";
import { DeleteIcon } from "../../Icon";

type AppProps = {
  toggleModal?: any;
  modal?: boolean;
  client_code?: number | string | null;
  token?: string | null;
  fetchNewData?: any;
  handleUploadFile?: (data: UploadFileTypesPayload) => void;
  currentFolder?: any;
  isDraggableModal?: boolean;
  acceptedFiles?: string;
  supportedFiles?: string;
  maxFileSize?: number;
  type?: string;
  handleGoBack: () => void;
  progressValue: number;
  fetching: boolean;
};

const OcrDropZone = ({
  toggleModal,
  type,
  modal,
  client_code,
  acceptedFiles,
  supportedFiles,
  maxFileSize,
  fetchNewData,
  handleUploadFile,
  isDraggableModal,
  handleGoBack,
  progressValue,
  fetching,
}: AppProps) => {
  const [fileNames, setFileNames] = useState("");

  const [fileData, setFileData] = useState<any>("");
  const [loading, setLoading] = useState(false);

  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  let blobSasUrl = `${blobBaseUrl}?${blobToken}`;

  const blobServiceClient = new BlobServiceClient(blobSasUrl);
  const containerName = `clientcontainer${client_code}`;
  const containerClient = blobServiceClient.getContainerClient(
    type ? "finaccrm" : containerName
  );

  const handleDrop = (acceptedFiles: any) => {
    if (type === "formattedFormData") {
      const nameAcceptedFiles = acceptedFiles.map((el: any) => {
        return new File([el], el.name, { type: el?.type });
      });
      setFileData(nameAcceptedFiles);
    } else {
      setFileData(acceptedFiles);
    }
    setFileNames(
      acceptedFiles && acceptedFiles.map((file: { name: any }) => file.name)
    );
  };

  const fileUpload = (e: any) => {
    setLoading(true);
    uploadFiles(fileData);
  };

  const handleFileDelete=()=>{
    setFileNames("")
    setFileData("")
  }

  const uploadFiles = async (uploadedFile: any) => {
    if (type === "formattedFormData") {
      return handleUploadFile?.(uploadedFile);
    }
    try {
      let resp;

      const blockBlobClient = containerClient.getBlockBlobClient(
        new Date().valueOf() +
          "." +
          uploadedFile[0].name.split(".")[
            uploadedFile[0].name.split(".").length - 1
          ]
      );

      resp = await blockBlobClient.uploadBrowserData(uploadedFile[0]);

      if (
        (resp &&
          resp["_response"] &&
          resp["_response"].status &&
          resp["_response"].status === 201) ||
        resp["_response"].status === 200
      ) {
        updateDocumentAPI(
          uploadedFile[0].name,
          blockBlobClient["_name"],
          blockBlobClient["_containerName"],
          uploadedFile[0].type
        );
        setLoading(false);
      } else {
        alert("something wrong");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const updateDocumentAPI = (
    file_name: string,
    url_name: string,
    url_container: string,
    file_type: string
  ) => {
    let data: UploadFileTypesPayload = {
      file_name,
      file_url: url_container + "/" + url_name,
      file_type,
    };

    handleUploadFile?.(data);
  };

  const renderDraggableUpload = () => {
    return (
      <div>
        <div className="col-md-4 mb-3">
          <CommonHeader title="Add OCR" />
        </div>
        <Dropzone
          accept={
            acceptedFiles ??
            "image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"
          }
          minSize={0}
          maxSize={maxFileSize ?? maxSize}
          onDrop={handleDrop}
          multiple={false}
        >
          {({
            getRootProps,
            getInputProps,
            isDragActive,
            isDragReject,
            fileRejections,
          }) => {
            let isFileTooLarge;
            if (maxFileSize) {
              isFileTooLarge = fileRejections[0]?.file?.size > maxFileSize;
            } else {
              isFileTooLarge = fileRejections[0]?.file?.size > maxSize;
            }

            return (
              <div className="mt-4">
                <div className="mt-2 mb-2 ocr_warning_text">
                  {" "}
                  <span>
                    <img src={WarningIcon} alt="warning" />
                  </span>{" "}
                  Please upload an image or PDF of the invoice. Note that the AI
                  model may not achieve 100% accuracy in processing. Kindly
                  review the extracted details before submitting.
                </div>

                <div
                  {...getRootProps({
                    className: "dropzone drop-area text-center",
                  })}
                >
                  <input {...getInputProps()} />
                  <img src={UploadIcon} alt="upload" />

                  {isDragActive && !isDragReject && (
                    <h4 className="text-center">Drop it like it's hot!</h4>
                  )}

                  {isDragReject && (
                    <h4 className="text-center">
                      File type not accepted, sorry!
                    </h4>
                  )}

                  {!isDragActive && (
                    <h4 className="text-center">
                      Drag'n'drop files, or click to select files
                    </h4>
                  )}
                  <p className="text-muted text-center">
                    {`Supported formats: ${
                      supportedFiles ??
                      "images, PDF, excel , ppt , pptx and doc."
                    }`}{" "}
                  </p>
                  <p className="text-center text-muted ">
                    {`Single file upload with maximum of ${displayFileSize} MB file size supported.`}
                  </p>
                  {isFileTooLarge && (
                    <div className="text-danger mt-2">File is too large.</div>
                  )}
                </div>
              </div>
            );
          }}
        </Dropzone>
        {fileNames ? <div className="d-flex align-items-center  mt-3 mb-3">
         <p className="m-0 pr-2 p-0"> {fileNames}</p>
        {loading? null : <img
                  className="ms-2"
                  src={RedDeleteIcon}
                  alt="delete-icon"
                  onClick={() => handleFileDelete()}
                  style={{ cursor: "pointer" }}
                />}
        </div> : null}
       

        {fetching ? (
          <>
            <p className="d-flex justify-content-center mt-3">
              Please wait while we upload your data and process it through our
              AI model. This may take a moment thank you for your patience!
            </p>
            <div className="mt-2 mb-2 d-flex justify-content-center">
              <Progress
                striped
                style={{
                  height: "15px",
                  marginRight: "10px",
                  width: "70%",
                  backgroundColor: "#bfcbe1",
                }}
                value={progressValue}
                color={"success"}
              ></Progress>
            </div>

            <div
              style={{ width: "70%", margin: "auto" }}
              className="text-right mt-2 text-success"
            >
              {progressValue} %
            </div>
          </>
        ) : null}

        <ModalFooter>
          {isDraggableModal && (
            <span className="pointer" onClick={() => handleGoBack()}>
              Cancel
            </span>
          )}
          {fileNames && fileNames.length ? (
            <Button color="primary" disabled={loading} onClick={fileUpload}>
              Upload
            </Button>
          ) : null}
        </ModalFooter>
      </div>
    );
  };

  const maxSize = 10000000; //10mb file size
  const displayFileSize =
    (maxFileSize && maxFileSize / 1000000) ?? maxSize / 1000000;
  return (
    <>
      {isDraggableModal ? (
        <div>{renderDraggableUpload()}</div>
      ) : (
        renderDraggableUpload()
      )}
    </>
  );
};

export default OcrDropZone;
